import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'images'
const verb = 'get'

export default class OspreyImagesGetThumbnails extends BaseAction {
    constructor(dataKey) {
        const id = '72735618-d486-4f45-9f1b-191a3634cb36'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getThumbnails(params) {
        this.params = Object.assign({
            fields: 'id,thumbnailUrl',
            pc: 8,
            archived: false
        }, params)

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/images/images-get-thumbnails.js